import React, { createContext, useContext, useState, useRef, useEffect } from 'react';

const DropdownMenuContext = createContext();

export const DropdownMenu = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <DropdownMenuContext.Provider value={{ isOpen, setIsOpen }}>
      <div className="relative inline-block">
        {children}
      </div>
    </DropdownMenuContext.Provider>
  );
};

export const DropdownMenuTrigger = ({ asChild, children, ...props }) => {
  const { setIsOpen } = useContext(DropdownMenuContext);
  
  if (asChild) {
    return React.cloneElement(children, {
      onClick: () => setIsOpen(prev => !prev),
      ...props,
    });
  }
  
  return (
    <button onClick={() => setIsOpen(prev => !prev)} {...props}>
      {children}
    </button>
  );
};

export const DropdownMenuContent = ({ className = '', align = 'start', children, ...props }) => {
  const { isOpen, setIsOpen } = useContext(DropdownMenuContext);
  const ref = useRef();
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, setIsOpen]);
  
  if (!isOpen) return null;
  
  return (
    <div
      ref={ref}
      className={`absolute z-50 mt-2 min-w-[8rem] overflow-hidden rounded-md border bg-white shadow-lg ${
        align === 'end' ? 'right-0' : 'left-0'
      } ${className}`}
      {...props}
    >
      <div className="p-1">
        {children}
      </div>
    </div>
  );
};

export const DropdownMenuItem = ({ className = '', children, onClick, ...props }) => {
  const { setIsOpen } = useContext(DropdownMenuContext);
  
  const handleClick = (e) => {
    onClick?.(e);
    setIsOpen(false);
  };
  
  return (
    <div
      onClick={handleClick}
      className={`relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-gray-100 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const DropdownMenuSeparator = ({ className = '', ...props }) => (
  <div className={`-mx-1 my-1 h-px bg-gray-200 ${className}`} {...props} />
);
